import {Modal, Button} from "react-bootstrap";
import clothesData from "./traits/clothes.json";
import shoesData from "./traits/shoes.json";
import handToolsData from "./traits/hand-tools.json";
import glovesData from "./traits/gloves.json";
import hairData from "./traits/hair.json";
import hatData from "./traits/hat.json";
import faceHairData from "./traits/face-hair.json";
import glassesData from "./traits/glasses.json";
import {useState} from "react";


function BaseImage(props: { file: string }) {
    const src = `/traits/${props.file}`
    return <img src={src}/>;
}

interface Props {
    width: string,
    height: string,
    clothes: number;
    shoes: number;
    handTools: number;
    gloves: number;
    hair: number;
    hat: number;
    faceHair: number;
    glasses: number;
}

function FarmerImage(props: Props) {
    const [details, setDetails] = useState(false);

    const showDetails = () => {
        setDetails(true);
    }

    const hideDetails = () => {
        setDetails(false);
    }

    const _clothes = clothesData.find(x => x.id === props.clothes);
    const _shoes = shoesData.find(x => x.id === props.shoes);
    const _handTools = handToolsData.find(x => x.id === props.handTools);
    const _gloves = glovesData.find(x => x.id === props.gloves);
    const _hair = hairData.find(x => x.id === props.hair);
    const _hat = hatData.find(x => x.id === props.hat);
    const _faceHair = faceHairData.find(x => x.id === props.faceHair);
    const _glasses = glassesData.find(x => x.id === props.glasses);

    return <div className="FarmerImage" style={{width: props.width, height: props.height}}>
        <div className="layer_0"><BaseImage file="body.png"/></div>
        {_clothes && <div className="layer_1"><BaseImage file={_clothes.file}/></div>}
        {_shoes && <div className="layer_2"><BaseImage file={_shoes.file}/></div>}
        {_handTools && <div className="layer_3"><BaseImage file={_handTools.file}/></div>}
        {_gloves && <div className="layer_4"><BaseImage file={_gloves.file}/></div>}
        {_hair && <div className="layer_5"><BaseImage file={_hair.file}/></div>}
        {_hat && <div className="layer_6"><BaseImage file={_hat.file}/></div>}
        {_faceHair && <div className="layer_7"><BaseImage file={_faceHair.file}/></div>}
        {_glasses && <div className="layer_8"><BaseImage file={_glasses.file}/></div>}
        <div className="layer_9" onClick={showDetails}/>


        {details && <>
          <Modal show={true} onHide={hideDetails}>
            <Modal.Header closeButton>
              <Modal.Title>Traits</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-trait-list">
                  {_clothes && <div className="modal-trait-detail"><h5>Clothes: {_clothes.name}</h5> <BaseImage
                      file={_clothes.file}/>
                  </div>}
                  {_shoes && <div className="modal-trait-detail"><h5>Shoes: {_shoes.name}</h5> <BaseImage
                      file={_shoes.file}/>
                  </div>}
                  {_handTools && <div className="modal-trait-detail"><h5>Hand Tools: {_handTools.name}</h5> <BaseImage
                      file={_handTools.file}/>
                  </div>}
                  {_gloves && <div className="modal-trait-detail"><h5>Gloves: {_gloves.name}</h5> <BaseImage
                      file={_gloves.file}/>
                  </div>}
                  {_hair && <div className="modal-trait-detail"><h5>Hair: {_hair.name}</h5> <BaseImage
                      file={_hair.file}/>
                  </div>}
                  {_hat && <div className="modal-trait-detail"><h5>Hat: {_hat.name}</h5> <BaseImage
                      file={_hat.file}/>
                  </div>}
                  {_faceHair && <div className="modal-trait-detail"><h5>Face Hair: {_faceHair.name}</h5> <BaseImage
                      file={_faceHair.file}/>
                  </div>}
                  {_glasses && <div className="modal-trait-detail"><h5>Glasses: {_glasses.name}</h5> <BaseImage
                      file={_glasses.file}/>
                  </div>}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary">Close</Button>
            </Modal.Footer>
          </Modal>
        </>}
    </div>
}

export default FarmerImage;